import { campaignCreateActions } from 'redux/reducers/campaignCreate.ts'
import { notifyError } from 'shared/errors/notificate.ts'

import { CONSTS } from '../config/objectConst.js'
import { campaignsActions } from '../redux/reducers/campaigns.ts'
import store from '../redux/store.ts'
import { campaign } from './campaign.js'

interface SendStep {
	message_template?: string
	reaction?: string
	timeout: number
	type: string
}

interface WorkingStep {
	name: string
	type: string
	values: {
		currentEmotion?: string
		delay?: number
		period?: number
		textarea?: string
	}
}

const adaptSteps = ({ type, values }: WorkingStep): SendStep => ({
	message_template: values.textarea || '',
	reaction:
		type === CONSTS.AVAILABLE_ACTIONS.ReactOnPost.Type
			? values.currentEmotion
			: undefined,
	timeout: values.period || 0,
	type
})

function insertDelay(steps: SendStep[], originals: WorkingStep[]) {
	const index = originals.findIndex(
		({ name }) => name === CONSTS.AVAILABLE_ACTIONS.Connect.Type
	)

	const isExist = index > -1,
		isLast = index === originals.length - 1

	if (isExist && !isLast) {
		const delayObject = {
			timeout: originals[index].values.delay || 0,
			type: 'Delay'
		}
		steps.splice(index + 1, 0, delayObject)
	}
}

export const campaignCreate = {
	editScrollEvent(value: boolean) {
		const action = campaignsActions.setScrollToAction(value)
		store.dispatch(action)
	},

	async save(stepValues: WorkingStep[], id: string, history: () => void) {
		try {
			const steps = stepValues.map(adaptSteps)
			insertDelay(steps, stepValues)
			const response = await campaign.updateCampaign({
				id,
				steps
			})

			if (response) {
				history()
			}
		} catch (error) {
			notifyError(error)
		}
	},

	zoomMessageWindow(value = '') {
		const action = campaignCreateActions.setZoom(value)
		store.dispatch(action)
	}
}
